<div class="container webview text-center" [@flyInOut]="'in'">
  <div class="col-sm-12 pt-5">
    <h1 class="text-center font-weight-normal-calibre questxt">{{question_sub1}}</h1>
    <h1 class="text-center font-weight-normal-calibre pb-4 questxt">{{question_sub2}}</h1>
  </div>
  <div class="col-sm-12">
    <div class="form-group col-sm-4 m-auto px-0">
      <input type="text" class="form-control"  [(ngModel)]="bizname" placeholder="Legal entity name"
        (keydown.space)="bizname ? null : $event.preventDefault()" (keyup)="enableButton($event)" (keyup.enter)="getBizname();"/>
    </div>
    <button *ngIf="showbutton" class="btn mr-2 ml-2 disabledButton col-sm-4 mt-4 font22 text-uppercase mx-4"
      style="width:auto !important; padding-left:25px; padding-right:25px;" [ngClass]="{'combtn': disablebutton}"
      (click)="getBizname();">Next</button>
  </div>
</div>
<div class="container mobileview mb-1 px-0 mt-4" style="float:left;" [attr.id]="questionObj._id">
  <div class="d-flex h-100 row col-sm-12 pr-0">
    <div class="justify-content-center align-self-center col-sm-3 col-3 pl-0">
      <img style="width:100%;" src="assets/images/logo-charcoal.png" />
    </div>
    <div class="col-sm-9 col-9 px-0 my-auto">
      <div class="arrow_box">
        <h1 class="questionMob text-left">{{question}}</h1>
      </div>
    </div>
  </div>
  <br />
  <div class="col-10 pull-right pl-4 mb-3">
    <form #f="ngForm" (ngSubmit)="getBizname();" novalidate>
      <div class="float-label-control">
        <label for="bizname">Legal entity name</label>
        <input class="focus-none" type="text" name="bizname" IsAlphaNumeric [(ngModel)]="bizname" placeholder="Legal entity name" id="Bizname"
          (keydown.space)="bizname ? null : $event.preventDefault()"
          (blur)="getBizname();"
          (keyup.enter)="getBizname(); $event.target.blur();">
      </div>
    </form>
  </div>
</div>